module.exports = __webpack_public_path__ + "static/media/juan-manuel-ottone.81badc1d.jpg";